<template>
  <v-dialog v-model="showExportDialog" max-width="480">
    <v-card v-if="welcome">
      <v-card-title class="headline">Dokumentenerstellung</v-card-title>
      <v-tabs v-model="tab">
        <v-tab ripple>Verzeichnis</v-tab>
        <v-tab ripple>TOMs</v-tab>
        <v-tab ripple>To-Do-Liste</v-tab>
        <v-tab v-if="isAdmin" ripple>Admin:Excel</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <p>
                Gemäß DSGVO ist jedes Unternehmen verpflichtet, den zuständigen Behörden auf Anfrage ein Verzeichnis der
                verwendeten Datenverarbeitungsverfahren sowie eine Aufstellung der technisch-organisatorischer Maßnahmen
                bereitzustellen.
              </p>
              <p>
                Hier können Sie für die <b>{{ company.fullname || company.name }}</b> ein aktuelles
                Verfahrensverzeichnis inklusive der TOMs erstellen.
              </p>
              <p>
                Es wird eine PDF-Datei erzeugt, das in der Dokumentablage gespeichert wird.
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <p>
                Im Falle eines Auftragsverarbeitungsvertrages (AVV) zwischen der
                {{ company.fullname || company.name }} und einem Auftraggeber ist der Auftraggeber dazu verpflichtet,
                die Technisch organisatorischen Maßnahmen (TOMs) der {{ company.fullname || company.name }} zu
                überprüfen. können Sie
              </p>
              <p>
                Wenn der Auftraggeber eine TOM-Aufstellung verlangt, können Sie hier eine aktuelle Aufstellung der
                Technisch organisatorischen Maßnahmen (TOMs) gemäß Art. 32 DSGVO erstellen, und diese dem Auftraggeber
                zur Verfügung stellen.
              </p>
              <p>
                Es wird eine PDF-Datei erzeugt, das in der Dokumentablage gespeichert wird.
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <p></p>
              <p>
                Hier können Sie eine Liste aller To-Dos erstellen.als Excel-Datei generieren. Leiten Sie diese Liste an
                die Zusändigen zur Abarbeitung weiter.
              </p>
              <p>
                Es wird eine Excel-Datei erzeugt, das in der Dokumentablage gespeichert wird.
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="isAdmin">
          <v-card flat>
            <v-card-text>
              Datenexport in eine SODA-Datei im Excel Format (Admin Feature)
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="discard()">
          Abbrechen
        </v-btn>
        <v-btn v-if="tab === 0" color="primary" outlined @click="genPDF()">
          <v-icon class="mr-2" dark>picture_as_pdf</v-icon> Verzeichnis erzeugen
        </v-btn>
        <v-btn v-if="tab === 1" color="primary" outlined @click="genTOMs()">
          <v-icon class="mr-2" dark>picture_as_pdf</v-icon> TOM-Aufstellung erzeugen
        </v-btn>
        <v-btn v-if="tab === 2" color="primary" outlined @click="genToDoXLS()">
          <v-icon class="mr-2" dark>assignment_turned_in</v-icon> To-Do-Liste erzeugen
        </v-btn>
        <v-btn v-if="tab === 3 && isAdmin" color="warning" outlined @click="genXLS()">
          Admin: XLS Export
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="loading" class="pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Daten laden
    </v-card>
    <v-card v-if="generating" class="pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Dokument generireren
    </v-card>
    <v-card v-if="saving" class="pa-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      Dokument speichern
    </v-card>
    <v-card v-if="done">
      <v-card-title class="headline">Dokument erstellt</v-card-title>
      <v-card-text>
        Ein Dokument für die {{ company.fullname || company.name }} wurde generiert und in der Dokumentenablage
        abgelegt. Um das Dokument jetzt zu sehen, wechseln Sie zu der Dokumentensicht.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="discard()">
          Abbrechen
        </v-btn>
        <v-btn color="primary" outlined @click="goToDocuments()">
          Zu den Dokumenten
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const { generatePDF } = require("../pdfgen.js");
const { generateXLS } = require("../xlsgen.js");
const { generateToDoXLS } = require("../todoxlsgen.js");

const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    fullname
    address_street
    address_street_no
    address_zip
    address_city
    address_country
    responsible_name
    responsible_role
    processes (limit: 500){
      items {
        id
        text_header
        seq_nr
        status
        text_legal
        legal_basis
        text_problem
        damage_scenario
        risk_probability
        data_category
        victim_risk
        damage_rate
        dept_resp
        recipient_category
        delete_period
        createdAt
        updatedAt
        archived_at
        deleted_at
        measures (limit: 100) {
          items {
            id
            label
            description
            status
            createdAt
          }
        }
        measureSets (limit: 20) {
          items {
            id
            status
            measureSet {
              id
              seq_nr
              type
              description
            }
          }
        }
      }
      nextToken
    }
    measureSets (limit: 50){
      items {
        id
        type
        seq_nr
        description
        commentatory
        status
        createdAt
        updatedAt
        measures (limit: 100) {
          items {
            id
            label
            description
            status
            createdAt
          }
        }
      }
      nextToken
    }
    createdAt
    updatedAt
    archived_at
    deleted_at
  }
}
`;

export default {
  name: "ExportView",
  props: {
    company: Object,
    showThis: Boolean,
  },
  computed: {
    getCompanyQuery() {
      return this.$Amplify.graphqlOperation(getCompany, { id: this.company.id });
    },
    prefix() {
      return this.$data.fullCompany.id + "/documents/";
    },
    isAdmin() {
      return (
        this.$store.state.originalStore.user_info.attributes.hasOwnProperty("custom:admin") &&
        this.$store.state.originalStore.user_info.attributes["custom:admin"] === "1"
      );
    },
  },
  data: () => ({
    welcome: true,
    loading: false,
    generating: false,
    saving: false,
    done: false,
    showExportDialog: false,
    fullCompany: null,
    loading: false,
    generate_type: "PDF",
    printOptions: {
      printProcesses: true,
      printMeasureSets: true,
      printArchived: false,
    },
    done: false,
    tab: 0,
  }),
  watch: {
    showThis: function(st) {
      this.showExportDialog = st;
    },
    showExportDialog: function(show) {
      if (show === false) {
        this.$emit("discard");
      }
    },
  },
  methods: {
    genXLS() {
      this.generate_type = "XLS";
      this.gen();
    },
    genToDoXLS() {
      this.generate_type = "ToDoXLS";
      this.gen();
    },
    genPDF() {
      this.printOptions.printProcesses = true;
      this.printOptions.printMeasureSets = true;
      this.generate_type = "PDF";
      this.gen();
    },
    genTOMs() {
      this.printOptions.printProcesses = false;
      this.printOptions.printMeasureSets = true;
      this.generate_type = "TOM";
      this.gen();
    },
    gen() {
      this.welcome = false;
      this.loading = true;
      this.loadFull();
    },
    loadFull() {
      this.$Amplify.API.graphql(this.getCompanyQuery).then((response) => this.onLoadedFull(response));
    },
    onLoadedFull(response) {
      this.fullCompany = response.data.getCompany;
      this.loading = false;
      this.generating = true;
      var genfunc =
        this.generate_type === "XLS" && this.isAdmin
          ? generateXLS
          : this.generate_type === "ToDoXLS"
          ? generateToDoXLS
          : generatePDF;
      var suffix = ["PDF", "TOM"].includes(this.generate_type) ? ".pdf" : ".xlsx";
      genfunc(this.fullCompany, this.printOptions, (buffer, tstamp) => {
        this.generating = false;
        this.saving = true;
        var prefix =
          this.generate_type === "ToDoXLS"
            ? "ToDoListe "
            : this.generate_type === "PDF"
            ? "VerfVz "
            : this.generate_type === "TOM"
            ? "TOMs "
            : "SODA ";
        this.putDocument(prefix + this.fullCompany.name + " " + tstamp.substr(0, 19) + suffix, buffer);
      });
    },
    putDocument(name, content) {
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.Storage.put(this.prefix + name, content, {
        level: "private",
        contentType: "application/octet-stream",
      })
        .then((result) => {
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Dokument",
            entity_label: name,
            sync_type: "save",
          });
          this.saving = false;
          this.done = true;
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Dokument",
            entity_label: name,
            sync_type: "save",
            error: err.errors[0].message,
          });
        });
    },
    goToDocuments() {
      this.discard();
      this.$router.push({ path: `/app/company/${this.fullCompany.id}/documents` });
    },
    discard() {
      this.showExportDialog = false;
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped></style>
